<template>
    <Dropdown
        placement="bottom-end"
        transfer
        trigger="custom"
        :visible="modelValue"
        @onClickoutside="$emit('update:model-value', false)"
    >
        <SquareButton :class="$style.button" :is-active="modelValue" @click="$emit('update:model-value', !modelValue)">
            <Icon size="22" type="ios-more" data-testid="banner-footer__options-button" />
        </SquareButton>

        <template #list>
            <DropdownItem
                v-for="option in options"
                :key="option.label"
                :divided="option.divided"
                @click="option.onClick"
            >
                <div :class="$style.label" :data-testid="`banner-footer__options-${option.id}`">
                    <Icon v-if="option.icon" :type="option.icon" />
                    <span>{{ option.label }}</span>
                </div>
            </DropdownItem>
        </template>
    </Dropdown>
</template>

<script lang="ts" setup>
import SquareButton from "@/components/common/SquareButton.vue";

const { options } = defineProps<{
    modelValue: boolean;
    options: { id: string; label: string; icon?: string; divided?: boolean; onClick: (args: unknown) => void }[];
}>();

const $emit = defineEmits<{
    (e: "update"): void;
    (e: "update:model-value", show: boolean): void;
}>();
</script>

<style lang="css" module>
.button {
    flex-basis: 40px;
}

.label {
    display: flex;
    align-items: center;
    gap: 8px;
}
</style>
